import { GR_ENV } from '../constants'
import type { Config } from './prod'
import { conf as prodConf } from './prod'
import { conf as preprodConf } from './preprod'
import { conf as qaConf } from './qa'

const config = GR_ENV === 'prod' ? prodConf : GR_ENV === 'preprod' ? preprodConf : qaConf

export const getConfig = (): Config => {
  return config
}
